import * as types from './types';

export const setApplicationComparedDataLoading = (isLoading = false) => ({
  type: types.APPLICATION_COMPARISON_SET_COMPARED_DATA_LOADING,
  isLoading
});

export const setApplicationComparedData = comparisonData => ({
  type: types.APPLICATION_COMPARISON_SET_COMPARED_DATA,
  comparisonData
});

export const resetApplicationComparedData = () => ({
  type: types.APPLICATION_COMPARISON_RESET_COMPARED_DATA
});

export const getApplicationComparedData = (schoolId, vacancyId, applicationBatch) => ({
  type: types.APPLICATION_COMPARISON_GET_COMPARED_DATA,
  schoolId,
  vacancyId,
  applicationBatch
});


// WEBPACK FOOTER //
// ./src/actions/applications/comparison/index.js